import { memoize } from "@use/decorators";

import { ContentElementData } from "@courses-pm2/api/src/ts/models/elements/ContentElementModel";
import { parseSimpleHtml } from "@courses-pm2/api/src/ts/parser/parseSimpleHtml";
import { CaptionedContentElementModel } from "./CaptionedContentElementModel";
import { ImageModel } from "./ImageModel";
import { RichtextModel } from "./RichtextModel";

type SplitProps = "options" | "image" | "text";

export type SplitData = {
  [K in SplitProps]: SplitModel[K];
};

export class SplitModel extends CaptionedContentElementModel {
  public options: {
    layout: "text-image" | "image-text";
    withGraphic: boolean;
    allowCrop: boolean;
  };

  public image: ImageModel;
  public text: RichtextModel;

  /**
   * Apply data given when a new model is being instantiated.
   */
  constructor(initial: SplitData & ContentElementData) {
    super(initial);

    this.options = initial.options;
    this.text = initial.text;
    this.image = initial.image;
  }

  /**
   * Helper that'll render the title of the slider, adding support for certain
   * simple html tags.
   */
  @memoize()
  public renderTitle(): React.ReactNode {
    return this.title ? parseSimpleHtml(this.title) : undefined;
  }

  @memoize()
  public async getPreviewImageUrl(): Promise<string> {
    return this.image.getPreviewImageUrl();
  }

  public getPreviewText(): string {
    return this.text.getPreviewText();
  }

  @memoize()
  public getStandardPageCount(): number {
    return this.text.getStandardPageCount();
  }
}
